const DEFAULT_LOCALE = "pt-BR";
const DEFAULT_CURRENCY = "BRL";

/** Reais → cents. A API guarda inteiro; a UI trabalha em unidade maior. */
export function toCents(amount: number): number {
  return Math.round(amount * 100);
}

/** Cents → reais. */
export function fromCents(cents: number): number {
  return cents / 100;
}

/** Formata um valor já em unidade maior (reais), como o resto da plataforma. */
export function formatBRL(value: number): string {
  return new Intl.NumberFormat(DEFAULT_LOCALE, {
    style: "currency",
    currency: DEFAULT_CURRENCY,
    minimumFractionDigits: 2,
  }).format(value);
}

/** Formata um valor guardado em cents. */
export function formatCents(
  cents: number,
  currency: string = DEFAULT_CURRENCY,
  locale: string = DEFAULT_LOCALE,
): string {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currency.toUpperCase(),
    minimumFractionDigits: 2,
  }).format(fromCents(cents));
}

/**
 * Texto digitado → cents. Aceita "1.234,56" (pt-BR) e "1234.56", ignorando
 * símbolo e espaços. Retorna null quando não sobra número.
 */
export function parseAmountToCents(input: string): number | null {
  const cleaned = input.replace(/[^\d,.-]/g, "").trim();
  if (!cleaned) return null;

  const lastComma = cleaned.lastIndexOf(",");
  const lastDot = cleaned.lastIndexOf(".");
  const decimalSeparator = lastComma > lastDot ? "," : ".";

  const normalized =
    decimalSeparator === ","
      ? cleaned.replace(/\./g, "").replace(",", ".")
      : cleaned.replace(/,/g, "");

  const value = Number(normalized);
  return Number.isFinite(value) ? toCents(value) : null;
}
